import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  UrlTree,
} from '@angular/router';
import { Observable, map } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { adminRoles, clientRoles } from '../roles';
import { UserAccessService } from '../user-access-service';


@Injectable({
  providedIn: 'root',
})
export class RoleAuthGuard implements CanActivate {
  constructor(
    private auth: AuthService,
    private permissionsService: UserAccessService) {}

  canActivate(
    next: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.permissionsService.getUserRoles().pipe(
          map((userRoles) => {
            // Wait for user roles to be loaded
            if (!userRoles || userRoles.length === 0) {
              // If no user roles yet, might still be loading
              return true; // Allow for now, Auth0 guard will handle auth
            }
            
            const allowedRolesArray = next.data['roles'] as string[];
            if (!allowedRolesArray || allowedRolesArray.length === 0) {
              return true; // No roles specified on route, allow access
            }
            
            const allowedRolesArrayLowercase: string[] = allowedRolesArray.map((str) => str.toLowerCase());
            const isRoleValid = userRoles.some(role => allowedRolesArrayLowercase.includes(role));

            if (!isRoleValid) {
              this.redirect(userRoles);
              return false;
            }

            return true;
          })
    );
  }

  private redirect(userRoles: string[]): void {
    const isUserAdmin = userRoles.some(
      userRole => adminRoles.some(
        adminRole => adminRole.toLowerCase() === userRole.toLowerCase()
      )
    );
    const isUserClient = userRoles.some(
      userRole => clientRoles.some(
        clientRole => clientRole.toLowerCase() === userRole.toLowerCase()
      )
    );

    if (isUserAdmin) {
      window.location.href = '/admin';
    } else if (isUserClient){
      window.location.href = '/';
    } else {
      this.auth.logout({logoutParams: {returnTo: document.location.origin}})
    }
  }

}
